/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_FinishInputs */

const en_us2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish workout`)
};

const pt_br2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir treino`)
};

const es_419_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar entrenamiento`)
};

const pt_pt2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir treino`)
};

const fr_fr2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer la séance`)
};

const de_de2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training abschließen`)
};

const it_it2_workout_finish = /** @type {(inputs: Workout_FinishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concludi allenamento`)
};

/**
* | output |
* | --- |
* | "Finish workout" |
*
* @param {Workout_FinishInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_finish = /** @type {((inputs?: Workout_FinishInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_FinishInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_finish(inputs)
	if (locale === "es-419") return es_419_workout_finish(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_finish(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_finish(inputs)
	if (locale === "de-DE") return de_de2_workout_finish(inputs)
	if (locale === "it-IT") return it_it2_workout_finish(inputs)
	return en_us2_workout_finish(inputs)
});
export { workout_finish as "workout.finish" }